export default "__VITE_ASSET__tzWmieC3__"